// extracted by mini-css-extract-plugin
export var scale = "scale-module--scale--6BBlj";
export var textContainer = "scale-module--textContainer--Wilsx";
export var referralPic0 = "scale-module--referralPic0--KvEgo";
export var referralPic1 = "scale-module--referralPic1--BqlgN";
export var referralPic2 = "scale-module--referralPic2--v9ej8";